import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { CUSTOMER_DETAILS } from '../../steps';
import Button from '../button';

export default function() {
  const { component } = useSelector(state => state.pageText.customerDetails);

  return (
    <Wrapper>
      <p>{component.noMsisdnText}</p>
      <Button
        className="confirm"
        disabled={false}
        name="Refresh (no msisdn)"
        onClick={() => window.location.reload()}
        step={CUSTOMER_DETAILS}
      >
        {component.refresh}
      </Button>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  p {
    color: red;
  }
`;
